import { Icons } from 'app/constants/icons';
import {Elegible} from '../utils/utils';

export const Info = ({elegible}: {elegible: Elegible}) => {
  if (elegible !== 'claimed') {
    return null;
  }
  return (
    <div className="mt-7 flex w-fit items-center gap-2 rounded-lg bg-dark-gunmetal-400 p-3 mobile:flex-col">
      <Icons.circleCheck className="h-5 w-5 text-success" />
      <p className="text-center text-sm">
        You&apos;ve already checked your allocation!
      </p>
    </div>
  );

  // return (
  //   <div className="mt-7 flex w-fit items-center gap-2 rounded-lg bg-dark-gunmetal-400 p-3 mobile:flex-col">
  //     <p className="text-center text-sm">
  //       Airdrop is going to be resumed in a few hours
  //     </p>
  //   </div>
  // );
  // switch (elegible) {
  //   case 'elegible':
  //     return (
  //       <div className="mt-7 rounded-lg bg-dark-gunmetal-400 p-3">
  //         <p className="text-center text-sm">
  //           Trust only the official Elys Network X account. If you&apos;re unsure
  //           avoid clicking any links.
  //         </p>
  //       </div>
  //     );
  //   case 'claimed':
  //     return (
  //       <div className="mt-7 flex w-fit items-center gap-2 rounded-lg bg-dark-gunmetal-400 p-3 mobile:flex-col">
  //         <p className="text-center text-sm">
  //           You&apos;ve already checked your allocation!
  //         </p>
  //       </div>
  //     );
  //   default:
  //     return null;
  // }
};
